export var WaveStatus;
(function (WaveStatus) {
    WaveStatus["DISABLED"] = "Disabled";
    WaveStatus["ENABLED"] = "Enabled";
    WaveStatus["UNKNOWN"] = "Unknown";
})(WaveStatus || (WaveStatus = {}));
